module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "promoterRegistration"
    }
  }, [_c('Background-Image', {
    attrs: {
      "url": "trees-vertical.jpg",
      "lowResUrl": "trees-vertical-lowres.jpg",
      "color": "#3E2723"
    }
  }), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid m-t-4 m-b-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-3 col-md-6"
  }, [_c('div', {
    staticClass: "m-t-4",
    attrs: {
      "id": "PromoterRegister"
    }
  }, [_c('div', {
    staticClass: "card padded"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-header brown darken-2"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.t('Login')))])]), _vm._v(" "), (_vm.expired) ? _c('div', {
    staticClass: "card card-warning text-xs-center z-depth-1 m-b-3"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('Your session has expired. Please confirm that you\'re still with us.')))])])]) : _vm._e(), _vm._v(" "), (this.$store.state.userDeprecated.unauthorized) ? _c('div', {
    staticClass: "card card-danger text-xs-center z-depth-1 m-b-3"
  }, [(this.$store.state.userDeprecated.unauthorizedStatus === 'Unauthorized') ? _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('Email/username or password don\'t match an account')))])]) : _vm._e(), _vm._v(" "), (this.$store.state.userDeprecated.unauthorizedStatus === 'Unapproved') ? _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('The Booknatura administration have not approved your account yet. If you need further assistance please contact info@booknatura.com')))])]) : _vm._e(), _vm._v(" "), (this.$store.state.userDeprecated.unauthorizedStatus === 'Unconfirmed') ? _c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('You still haven\'t confirmed your account. Please check your email for confirmation instructions. If you need further assistance please contact info@booknatura.com')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$store.state.userDeprecated.unprocessable) ? _c('div', {
    staticClass: "card card-warning text-xs-center z-depth-1 m-b-3 "
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(_vm.t('You must fill the username/email and password fields')))])])]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser()
      }
    }
  }, [_c('Text-Input', {
    attrs: {
      "data": this.$store.state.userDeprecated.form.emailUsername
    }
  }), _vm._v(" "), _c('Text-Input', {
    attrs: {
      "data": this.$store.state.userDeprecated.form.password,
      "type": "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(!this.$store.state.userDeprecated.isUserLoggingIn) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "id": "submitLoginPromoter"
    },
    on: {
      "click": function($event) {
        _vm.loginUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Login')))]) : _vm._e(), _vm._v(" "), (this.$store.state.userDeprecated.isUserLoggingIn) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loginUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('p', [_vm._v(_vm._s(_vm.t('Don\'t have an account yet?')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.registerURL
    }
  }, [_vm._v(_vm._s(_vm.t('Register')))])], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Forgot your password?')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.recoverURL
    }
  }, [_vm._v(_vm._s(_vm.t('Recover')))])], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Are you a supplier and don\'t have an account yet?')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.promoterRegisterURL
    }
  }, [_vm._v(_vm._s(_vm.t('Register as a supplier')))])], 1)])])])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c7b6ecf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7b6ecf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Login.vue
// module id = 781
// module chunks = 3